import types from "../types"

export default {
  set: function observerSet(engine, model, observer) {
    return {
      type: types.setObserver,
      engine,
      model,
      observer,
    }
  },
  unset: function observerUnset(type, task, engine, model) {
    return {
      type: types.unsetObserver,
      engine,
      model,
    }
  },
}
